





















import { get_table_config } from "./data/table.config";
import VirtualTable from "@/components/table/VirtualTable.vue";
import TableRow from "./TableRow.vue";
import Vue from "vue";
import ResultsFilter from "./ResultsFilter.vue";
import { state } from "./data/state";
import { computed, onBeforeUnmount, onMounted } from "@vue/composition-api";
import { SharedState } from "@/common/state";
import { emptyFn } from "@/fp";
import { EventBus } from "@/eventbus";
import { UseModal } from "@/components/root/modal";
import EventJustificaionDetailsModalVue from "./EventJustificaionDetailsModal.vue";
export default Vue.extend({
  components: { ResultsFilter, VirtualTable },
  setup() {
    const {
      justifications,
      is_loading,
      has_no_results,
      load_more,
      init,
      show_pending_list,
    } = state;

    const subs = {
      details: emptyFn(),
    };
    onMounted(() => {
      SharedState.onReady(async () => {
        await init();
      });

      subs.details = EventBus.listen("details", async (item: any) => {
        await UseModal().show(EventJustificaionDetailsModalVue, {
          justification: item.event_details,
          event_id: item.event_id,
        });
      });
    });

    onBeforeUnmount(() => {
      Object.values(subs).forEach((unsub) => unsub());
    });
    return {
      TableRow,
      table_config: computed(() => get_table_config(show_pending_list.value)),
      justifications,
      is_loading,
      load_more,
      has_no_results,
    };
  },
});
